import { MDBAlert, MDBBtn, MDBDatatable, MDBIcon, MDBInput, MDBSpinner } from 'mdb-react-ui-kit';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getcustomContactFields } from '../../../apiclients/streamsapi_bridge';
import CreateEditCutomField from '../../../views/popups/globalaccount/CreateEditCutomField';
import DeleteCustomField from '../../../views/popups/globalaccount/DeleteCustomField';
import PopupLoader from '../../../views/popups/PopupLoader';
import PopupLoaderNew from '../../../views/popups/PopupLoaderNew';
import { customSearch, useAutoFocusSearchAfterLoads } from '../../CustomSearchUtil/CustomSearch';
import UIConstant from '../../../apiclients/UIConstant';
import TabIDConstant from '../../../apiclients/TabIDConstant';

function ManageCustomFields({isActive}) {

    const [centredModal4, setCentredModal4] = useState(false);
    const toggleOpen4 = () => setCentredModal4(!centredModal4);
    const [internalError, setInternalError] = useState(false);
    const [customFields, setcustomFields] = useState([]);
    const [isloading, setIsloading] = useState(false);
    const [isLoading, setisLoading] = useState(false);
    const addContactRef = useRef(null);
    const { t, i18n } = useTranslation();
    const [deleteID, setdeleteID] = useState();
    const [customFieldInfo, setcustomFieldInfo] = useState({});
    const [editFlag, seteditFlag] = useState(false);
    const [deleteFeild, setdeleteFeild] = useState(false);
    const dtogglePopup = () => setdeleteFeild(!deleteFeild);

    const [searchValue, setsearchValue] = useState("");
    const [filteredRows, setFilteredRows] = useState([]);
    const [rowdata, setRowData] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
        useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef,isActive)
    useEffect(() => {
        if(isActive){
        getAllCustomField();
        }
    }, [isActive]);

    async function handleDelete(e, id) {
        e.preventDefault();
        e.stopPropagation();
        setdeleteID(parseInt(id));
        setdeleteFeild(true);
    }

    const showThisInfo = (e) => {
        seteditFlag(true);
        setcustomFieldInfo(e.customInfo);
        toggleOpen4();
    }


    async function getAllCustomField() {
        setInternalError(false);
        setIsloading(true);
        console.log(sessionStorage.getItem("admin_session"));
        const response = await getcustomContactFields(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            TabIDConstant.MNG_CUST_FIELDS_SUBLINK
        );
        setIsloading(false);
        if (!response.json) {
            const message = `An error has occured: ${response.statusText}`;
            return;
        }
        const rawData = await response.json();
        if (!rawData) {
            setInternalError(true);
        }
        console.log("getcustomContactFields data :::::::::: " + JSON.stringify(rawData));
        setcustomFields(rawData?.customFieldsDtls ?? []);
        setTimeout(() => {
            setIsloading(false);
        }, 1000);
    }

    useEffect(() => { 
    let processdrows = [];
    customFields.map((custom) => {

        processdrows.push({
            customInfo: custom,
            name: custom.label + "",
            type: custom.field_type == 1 ? "Text Box" : "Text Area",
            action: (
                <>
                    <div className="d-flex align-items-center ms-2">
                        <div className="custom-hover-bg p-1 ms-2 cursor-pointer deleteToolTip"
                            onClick={(e) => handleDelete(e, custom.field_id)}
                        >
                            <MDBIcon fas icon="times" color="primary" className="mx-2 my-1 fs-5" />
                        </div>
                    </div>
                </>
            ),



        })
    });
    setRowData(processdrows);
    setFilteredRows(processdrows)
    setDataLoaded(true)
},[customFields])

    const actionData3 = {
        columns: [
            { label: 'Name', field: 'name', sort: true },
            { label: 'Type', field: 'type' },
            { label: 'Action', field: 'action', sort: false },
        ],
        rows: rowdata,
    };

    function handleClick() {
        addContactRef.current.click();
    }


    const handleManualSearch = (searchValue) => {
        setsearchValue(searchValue);
        const filteredUsers = customSearch(rowdata, searchValue, UIConstant.CONTCAT_CUSTOM_FIELD);

        setFilteredRows(filteredUsers);
    };


    return (
        <>
            <div className="d-flex align-items-center justify-content-between actionbar">
                <MDBBtn onClick={toggleOpen4}
                    className="green-button d-inline-block float-end"
                ><MDBIcon fas icon="add" size="sm" className='me-2' />Add Custom Field
                </MDBBtn>
            </div>
            <div className='contactsTable'>
                <div className="actionbar"></div>
                <div className='mb-2 mt-2 position-relative w-auto'>
                    <MDBInput ref={searchRef} label="Search" value={searchValue}  onChange={(e) => handleManualSearch(e.target.value)} />
                    <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                </div>
                <MDBDatatable hover  key={searchValue} 
                data={{
                    ...actionData3,
                    rows: filteredRows, // Use filtered rows here
                  }}
                   entries={50} sortField="Name" onRowClick={(e) => showThisInfo(e)} />
            </div>
            {/* <MDBModal tabIndex='-1' open={centredModal4} setShow={setCentredModal4}>
                <MDBModalDialog centered>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Create Custom Field</MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={toggleOpen4}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            <div className="tel-numbers mt-2">
                                <strong>Field Name</strong>
                            </div>
                            <div className="form pt-1 w-100">
                                <input type="text" className="w-100 form-control" />
                            </div>
                            <div className="tel-numbers mt-2">
                                <strong>Field Type</strong>
                            </div>
                            <div className="form pt-1 w-100">

                                <select
                                    className="form-control form-select selectname w-100"
                                    name="San Jose"
                                >
                                    <option value="San Jose">
                                        Text Box
                                    </option>
                                    <option value="San Jose">
                                        Text Area
                                    </option>
                                </select>
                            </div>
                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn color='secondary' onClick={toggleOpen4}>
                                Close
                            </MDBBtn>
                            <MDBBtn>Add</MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal> */}

            {centredModal4 && (
                <PopupLoaderNew
                    title={editFlag ? t('Edit Custom Field') : t('Add Custom Field')}
                    content={<CreateEditCutomField
                        onClose={toggleOpen4}
                        ref={addContactRef}
                        setIsloading={setisLoading}
                        customInfo={editFlag ? customFieldInfo : null}
                        editFlag={editFlag}
                    />}
                    onShow={setCentredModal4}
                    onClose={toggleOpen4}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag = {1}
                />
            )}

            {deleteFeild && (
                <PopupLoader
                    title={"Remove Custom Field"}
                    content={<DeleteCustomField
                        fieldId={deleteID}
                        onClose={dtogglePopup}
                    />}
                    onShow={setdeleteFeild}
                    onClose={dtogglePopup}
                />
            )}


            {internalError && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={5000}
                    onClose={() => setInternalError(false)}
                >
                    Internal Server Error
                </MDBAlert>
            )}
            {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )}

        </>
    )
}

export default ManageCustomFields
